module.exports = __webpack_public_path__ + "img/news15_6.68dcbb78.jpg";